import React, { Component} from "react";

// material ui core grid
import { Grid } from '@material-ui/core';

// react redux connect
import { connect } from 'react-redux';

// js moment
import moment from 'moment';

// material ui pickers
import MomentUtils from '@date-io/moment';

import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// homemade components
import {
  ProfileCard,
  RegularCard,
  Button,
  CustomInput,
  ItemGrid,
  Table
} from "../../components";

// edit user action
import { editUser } from './reducer/actions';

// Send a wire down to the main office, tell them that I said-OWWW
// Tell them you said "OWWW", got it

// class declaration
class UserProfile extends Component {

  // initial state
  state = {
    name: '',
    point: 0,
    birthday: new Date(),
    profileImage: null,
  }

  // get state from user object
  componentDidMount () {
    const { user = {} } = this.props;

    this.setState({
      name: user.name,
      point: user.point || 0,
      birthday: user.birthday,
      profileImage: user.profileImage,
    });
  }

  // navigate back to Users screen after successful edit
  _onSuccess () {
    this.props.history.push('/users');
  }

  // log error if edit is not successful
  _onError (error) {
    console.log(error);
  }

  // called when edit button is pressed
  _onEditProfile () {
    this.props.editUser(this.props.user.id, {
      name: this.state.name,
      point: this.state.point || 0,
      birthday: this.state.birthday ? moment(this.state.birthday).format(): null,
      profileImage: this.state.profileImage || null,
      rewards: this.props.user.rewards || {},
      id: this.props.user.id
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // component render
  render() {
    // if no user was passed to this page, go to home page
    if (this.props.user === undefined) {
      this.props.history.push('/');
      return <div />
    }

    // get user rewards
    const { rewards = {} } = this.props.user;

    // map all rewards to their name and date
    const rewardsData = Object.keys(rewards).map(v => [rewards[v].name, moment(rewards[v].date).format('ll')]);

    // render return
    return (
      <div>
        <MuiPickersUtilsProvider utils={MomentUtils}>
        <Grid container>
          <ItemGrid xs={8}>
          {this.props.user !== undefined &&
            <RegularCard
              cardTitle={this.props.user.name}
              cardSubtitle="Edit User Profile"
              content={
                <div>
                  <Grid container>
                    {/* Name input field */}
                    <ItemGrid xs={6}>
                      <CustomInput
                        labelText="Name"
                        id="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.name,
                          onChange: (evt) => this.setState({ name: evt.target.value })
                        }}
                      />
                    </ItemGrid>
                    <ItemGrid xs={6} />
                    {/* Birthday input field */}
                    <ItemGrid xs={6}>
                      <DatePicker
                        label="Birthday"
                        id="birthday"
                        value={this.state.birthday}
                        onChange={(date) => this.setState({ birthday: date })}
                      />
                    </ItemGrid>
                    <ItemGrid xs={6} />
                    {/* Point input field */}
                    <ItemGrid xs={6}>
                      <CustomInput
                        labelText="Points"
                        id="points"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.point,
                          onChange: (evt) => this.setState({ point: evt.target.value })
                        }}
                      />
                    </ItemGrid>
                  </Grid>
                </div>
              }
              footer={
                /* update profile button */
                <Button color="primary"
                  onClick={this._onEditProfile.bind(this)}
                >
                  Update Profile
                </Button>
              }
            />
          }
          </ItemGrid>
          {/* Member card on right side with profile image */}
          <ItemGrid xs={12} sm={12} md={4}>
            <ProfileCard
              avatar={this.state.profileImage}
              subtitle="Member"
              title={this.props.user.name}
            />
          </ItemGrid>
          {/* Current Rewards card on lower left */}
          <ItemGrid xs={12} sm={12} md={6}>
            <RegularCard
              headerColor="orange"
              cardTitle="Rewards"
              content={
                <Table
                  tableHeaderColor="warning"
                  tableHead={["Title", "Earned At"]}
                  tableData={rewardsData}
                />
              }
            />
          </ItemGrid>
          {/* Past Rewards card on lower right */}
          <ItemGrid xs={12} sm={12} md={6}>
            <RegularCard
              headerColor="green"
              cardTitle="Rewards History"
              content={
                <Table
                  tableHeaderColor="warning"
                  tableHead={["Date", "History"]}
                  tableData={[]}
                />
              }
            />
          </ItemGrid>
        </Grid>
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

const getUserWithId = (usrArr, uid) => {
  return usrArr.filter((usr) => (usr.id === uid))[0];
};

const mapStateToProps = state => ({
  user: getUserWithId(state.userReducer.users, state.userReducer.selectedUser)
});

const mapDispatchToProps = {
  editUser
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
